import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Charity from '@/views/Charity.vue'
import Login from '@/views/Login.vue'
import YourRallies from '@/views/YourRallies.vue'
import Register from '@/views/Register.vue'
import RallyRegister from '@/views/RallyRegister.vue'
import TeamSite from '@/views/TeamSite.vue'
import Teams from '@/views/Teams.vue'
import CustomerSearch from '@/views/admin-area/CustomerSearch.vue'
import CrewSearch from '@/views/admin-area/CrewSearch.vue'
import Discounts from '@/views/admin-area/Discounts.vue'
import TeamSearch from '@/views/admin-area/TeamSearch.vue'
import Admin from '@/views/admin-area/Admin.vue'
import VehicleSearch from '@/views/admin-area/VehicleSearch.vue'
import RallySearch from '@/views/admin-area/RallySearch.vue'
import Votings from '@/views/admin-area/Votings.vue'
import Vote from '@/views/Vote.vue'
import AdminPoints from '@/views/admin-area/Points.vue'
import Chat from '@/views/Chat.vue'
import Customer from '@/views/Customer.vue'
import RegisterState from '@/views/RegisterState.vue'
import Forget from '@/views/Forget.vue'
import ResetPassword from '@/views/ResetPassword.vue'
import Base from '@/views/Base.vue'
import Content from '@/views/Content.vue'
import RallyRounds from '@/views/admin-area/RallyRounds.vue'
import Rallies from '@/views/admin-area/Rallies.vue'
import RallyRound from '@/views/admin-area/RallyRound.vue'
import Terms from '@/views/admin-area/Terms.vue'
import RegisterGuide from '@/views/RegisterGuide.vue'
import Registration from '@/views/admin-area/Registration.vue'
import DbCheck from '@/views/admin-area/DbCheck.vue'
import RegistrationCheck from '@/views/admin-area/RegistrationCheck.vue'
import EventLog from '@/views/admin-area/EventLog.vue'
import Waiting from '@/views/Waiting.vue'
import RateChallenges from '@/views/admin-area/RateChallenges.vue'
import Donate from '@/views/charity/Donate.vue'
import UserPoints from '@/views/Points.vue'
import LiabilityDisclaimer from '@/views/LiabilityDisclaimer.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/charity.php',
    name: 'Charity',
    component: Charity
  },
  {
    path: '/login',
    alias: ['/', '/login.php'],
    name: 'Login',
    component: Login
  },
  {
    path: '/reset-password',
    alias: ['/resetpassword.php'],
    name: 'Reset Password',
    component: ResetPassword
  },
  {
    path: '/forget',
    alias: ['/forget.php'],
    name: 'Forgot Password',
    component: Forget
  },
  {
    path: '/your-rallies',
    alias: ['/yourRallies.php'],
    name: 'YourRallies',
    component: YourRallies,
    meta: {
      title: 'Meine Rodeos'
    }
  },
  {
    path: '/register-stats',
    alias: ['/register-stats.php'],
    name: 'RegisterStats',
    component: () => import('@/views/admin-area/RegisterStats.vue'),
    meta: {
      title: 'Statistik Registrierungen',
      link: {
        to: '/admin'
      }
    }
  },
  {
    path: '/register',
    alias: ['/register.php'],
    name: 'Register',
    component: Register
  },
  {
    path: '/rally-register',
    alias: ['/rallyRegister.php'],
    name: 'RallyRegister',
    component: RallyRegister,
    meta: {
      title: 'Anmeldung zum Rodeo'
    }
  },
  {
    path: '/teams/:rallyRoundId/team/:teamId?',
    alias: ['/team.php/:rallyRoundId:/:teamId?', '/team', '/team.php', '/team/:rallyRoundId?/:teamId?'],
    name: 'TeamSite',
    component: TeamSite
  },
  {
    path: '/teams/:rallyRoundId?',
    alias: ['/teams.php/:rallyRoundId?'],
    name: 'Teams',
    component: Teams,
    meta: {
      rallyRoundPage: true
    }
  },
  {
    path: '/admin/customers',
    alias: ['/customer.list-new.php'],
    name: 'Customer Search',
    component: CustomerSearch
  },
  {
    path: '/team.list.php',
    name: 'Team Search',
    component: TeamSearch
  },
  {
    path: '/vehicle.list.php',
    name: 'Vehicle Search',
    component: VehicleSearch
  },
  {
    path: '/admin',
    alias: ['/profil.php'],
    name: 'Admin',
    component: Admin,
    meta: {
      title: 'Admin Area'
    }
  },
  {
    path: '/teamarea-statistik.php',
    alias: ['teamarea-statistics'],
    name: 'Teamarea Statistik',
    component: () => import('@/views/admin-area/TeamareaStats.vue')
  },

  {
    path: '/rally.list.php',
    name: 'Rally Search',
    component: RallySearch
  },
  {
    path: '/voting.list.php',
    name: 'Votings',
    component: Votings
  },
  {
    path: '/vote.php',
    name: 'Vote',
    component: Vote
  }, {
    path: '/admin/points',
    name: 'AdminPoints',
    component: AdminPoints,
    meta: {
      title: 'Bestenliste'
    }
  },
  {
    path: '/points/:rallyRoundId',
    name: 'UserPoints',
    component: UserPoints,
    meta: {
      title: 'Bestenliste'
    }
  },
  {
    path: '/rally/:rallyRoundId?',
    alias: ['/rally.php/:rallyRoundId?'],
    name: 'Chat',
    component: Chat,
    meta: {
      rallyRoundPage: true
    }
  }, {
    path: '/customer',
    alias: ['/customer.php'],
    name: 'Customer',
    component: Customer,
    meta: {
      title: 'Meine Daten'
    }
  }, {
    path: '/register-state/:cuid',
    alias: ['/register.state.php/:cuid'],
    name: 'Register State',
    component: RegisterState,
    meta: {
      title: 'Deine Anmeldung'
    }
  }, {
    path: '/discounts',
    name: 'Discounts',
    component: Discounts,
    meta: {
      title: 'Discounts',
      link: {
        to: '/admin'
      }
    }
  },
  {
    path: '/admin/rally-rounds',
    name: 'RallyRounds',
    component: RallyRounds,
    meta: {
      title: 'Rally Runden',
      link: {
        to: '/admin'
      }
    }
  },
  {
    path: '/admin/rallies',
    name: 'Rallies',
    component: Rallies,
    meta: {
      title: 'Rallies',
      link: {
        to: '/admin'
      }
    }
  },
  {
    path: '/admin/rally-rounds/:rallyRoundId',
    name: 'RallyRound',
    component: RallyRound,
    meta: {
      title: 'Rally Runde bearbeiten',
      link: {
        to: '/admin/rally-rounds'
      }
    }
  },
  {
    path: '/base/:rallyRoundId',
    alias: ['/team.menu.php'],
    name: 'Base',
    component: Base,
    meta: {
      rallyRoundPage: true
    }
  },
  {
    path: '/base/:rallyRoundId/content/:contentId',
    name: 'Content',
    component: Content
  },
  {
    path: '/disclaimer/:id',
    name: 'Haftungsausschluss',
    component: LiabilityDisclaimer,
    meta: {
      title: 'Haftungsausschluss',
      link: {
        to: '/'
      }
    }
  },
  {
    path: '/admin/terms',
    name: 'Terms',
    component: Terms
  },
  {
    path: '/register.guide.php/:cuid',
    alias: '/create-team/:cuid',
    name: 'Register Guide',
    component: RegisterGuide,
    meta: {
      title: 'Deine Startdaten',
      link: {
        to: '/your-rallies'
      }
    }
  },
  {
    path: '/teamarea/admin/registrations',
    name: 'Registrations',
    component: Registration,
    meta: {
      title: 'Registrierungen verwalten',
      wide: false,
      link: {
        to: '/admin/rally-rounds'
      }
    }
  },
  {
    path: '/teamarea/admin/db-check',
    name: 'DbCheck',
    component: DbCheck,
    meta: {
      title: 'Database Checker'
    }
  },
  {
    path: '/waiting/:rallyRoundId',
    name: 'Waiting',
    component: Waiting
    /* meta: {
      title: 'Bereich geschlossen'
    } */
  }, {
    path: '/teamarea/admin/registration-check',
    name: 'RegistrationCheck',
    component: RegistrationCheck,
    meta: {
      title: 'Problembehaftete Registrierungen',
      link: {
        to: '/admin'
      }
    }
  },
  {
    path: '/teamarea/admin/event-log',
    name: 'EventLog',
    component: EventLog,
    meta: {
      title: 'Ereignislog',
      link: {
        to: '/admin'
      }
    }
  },
  {
    path: '/teamarea/admin/rally-rounds/:rallyRoundId/challenges',
    name: 'RateChallenges',
    component: RateChallenges,
    meta: {
      title: 'Challenges bewerten',
      link: {
        to: '/admin'
      }
    }
  },
  {
    path: '/teamarea/admin/crew',
    name: 'Crew Search',
    meta: {
      title: 'Crewliste',
      link: {
        to: '/admin'
      }
    },
    component: CrewSearch
  },
  {
    path: '/charity/donate/:shopDonateId/:teamId',
    name: 'Donate',
    component: Donate
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
